// Form-shape Zod schema (FNP-58 moved this app's form schemas from Yup to Zod).
// All three fields are required by CreateProviderMappingInput; without this an empty
// submit went on to look up a billing provider of id ''.
import {z} from 'zod';

export const CreateFormSchema = z.object({
    entityType: z.string().min(1, 'Entity type is required'),
    localEntityId: z.string().min(1, 'Local entity ID is required'),
    billingProviderId: z.string().min(1, 'Billing provider is required'),
});
